export default __webpack_public_path__ + "static/media/06-extreme-users.c1ba2dc3.svg";